import * as THREE from 'three'
import { NUMERIC_LERP_RATE } from '../settings/appSettings.js'

export function dampNumber(current, target, deltaTime) {
  const amount = 1 - Math.exp(-NUMERIC_LERP_RATE * Math.max(deltaTime, 0))
  return THREE.MathUtils.lerp(current, target, amount)
}

export function isValidVec3(value) {
  return Array.isArray(value) && value.length === 3 && value.every(Number.isFinite)
}
